//
// Wave Animation Resize Fix
// --------------------------------------------------
// Fixes wave animation positioning issues on window resize

window.addEventListener('load', () => {
    let resizeTimeout;

    function forceWaveRefresh() {
        const waveElement = document.getElementById('waveAnimation');
        if (!waveElement) return;

        // Temporarily disable animations
        waveElement.style.setProperty('--disable-waves', '1');

        // Force reflow
        waveElement.offsetHeight;

        // Re-enable animations
        requestAnimationFrame(() => {
            waveElement.style.removeProperty('--disable-waves');
        });
    }

    function handleResize() {
        // Clear any existing timeout
        clearTimeout(resizeTimeout);

        // Set a timeout to handle the resize after it's finished
        resizeTimeout = setTimeout(() => {
            forceWaveRefresh();
        }, 100);
    }

    // Use resize listener
    window.addEventListener('resize', handleResize, { passive: true });
});
